<div [id]="id()">
    <!-- todo: uncomment this when implementing templates functionality -->
    <!-- <app-alert
  [alertSeverityType]="alertSeverityTypes.Info"
  [alertType]="alertTypes.Secondary"
  id="order-save-as-template-alert">
  <div>
    <p>{{ 'orders.setup.orderSummary.orderDetailsAlertText' | translate }}</p>
    <p id="order-save-as-template-button">
      {{ 'orders.setup.orderSummary.orderDetailsAlertAction' | translate }}
    </p>
  </div>
</app-alert> -->

    @for (retest of sortedRetests(); track retest; let i = $index) {
        <div>
            @if (retest) {
                <div id="order-retests-container">
                    <p class="table-label">
                        {{ 'order.orderDetailsRetestReactions' | translate }}: {{ retestReactionsNumbers()[i] }} [{{
                            retest.compositName
                        }}]
                    </p>
                    <div class="table-header">
                        <div>{{ 'sample' | translate }}</div>
                        <div>{{ 'order.orderDetailsPrimers' | translate }}</div>
                    </div>
                    @for (reaction of retest.reactions; track reaction; let index = $index) {
                        <div class="table-row">
                            <p [id]="'order-details-retest-name-' + index">
                                {{ reaction.sampleName }}
                            </p>
                            <div>
                                @for (
                                    primer of reaction.primers;
                                    track primer;
                                    let lastPrimerName = $last;
                                    let primerIndex = $index
                                ) {
                                    <p
                                        [id]="'order-details-retest-primer-' + index"
                                        [class.cancelled]="primer.cancelledAt">
                                        {{ primerIndex + 1 }}. {{ primer.name }}
                                        @if (!lastPrimerName) {}
                                    </p>
                                }
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }

    @for (retest of sortedRetests(); track retest; let i = $index) {
        <div>
            @if (sortedRetests().length) {
                <div id="order-retests-container-mobile">
                    <p class="table-label">
                        {{ 'order.orderDetailsRetestReactions' | translate }}: {{ retestReactionsNumbers()[i] }} [{{
                            retest.compositName
                        }}]
                    </p>
                    @for (reaction of retest.reactions; track reaction; let index = $index) {
                        <div class="table-row" [ngClass]="index % 2 === 0 ? 'even' : 'odd'">
                            <div class="item">
                                <span class="label">{{ 'sample' | translate }}:</span>
                                <p [id]="'order-details-retest-name-' + index">
                                    {{ reaction.sampleName }}
                                </p>
                            </div>
                            <div class="item">
                                <span class="label">{{ 'order.orderDetailsPrimers' | translate }}:</span>
                                <div>
                                    @for (primer of reaction.primers; track primer; let lastPrimerName = $last) {
                                        <p
                                            [class.cancelled]="primer.cancelledAt"
                                            [id]="'order-details-reaction-primer-' + index">
                                            {{ primer.name }}
                                            @if (!lastPrimerName) {
                                                ;
                                            }
                                        </p>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    }

    <div id="order-reactions-container">
        <p class="table-label">{{ 'order.orderDetailsReactions' | translate }}: {{ numberOfReactions() }}</p>
        <div class="table-header">
            <div>{{ 'sample' | translate }}</div>
            <div>{{ 'order.orderDetailsPrimers' | translate }}</div>
        </div>
        @for (reaction of reactions(); track reaction; let index = $index) {
            <div class="table-row">
                <p [id]="'order-details-reaction-name-' + index" [class.cancelled]="reaction.isCancelled">
                    {{ reaction.sampleName }}
                </p>
                <div>
                    @for (
                        primer of reaction.primers;
                        track primer;
                        let lastPrimerName = $last;
                        let primerIndex = $index
                    ) {
                        <p [id]="'order-details-reaction-primer-' + index" [class.cancelled]="primer.cancelledAt">
                            {{ primerIndex + 1 }}. {{ primer.name }}
                            @if (!lastPrimerName) {}
                        </p>
                    }
                </div>
            </div>
        }
    </div>

    <div id="order-reactions-container-mobile">
        <p class="table-label">{{ 'order.orderDetailsReactions' | translate }}: {{ numberOfReactions() }}</p>
        @for (reaction of reactions(); track reaction; let index = $index) {
            <div class="table-row" [ngClass]="index % 2 === 0 ? 'even' : 'odd'">
                <div class="item">
                    <span class="label">{{ 'sample' | translate }}:</span>
                    <p [id]="'order-details-reaction-name-' + index" [class.cancelled]="reaction.isCancelled">
                        {{ reaction.sampleName }}
                    </p>
                </div>
                <div class="item">
                    <span class="label">{{ 'order.orderDetailsPrimers' | translate }}:</span>
                    <div>
                        @for (primer of reaction.primers; track primer; let lastPrimerName = $last) {
                            <p [class.cancelled]="primer.cancelledAt" [id]="'order-details-reaction-primer-' + index">
                                {{ primer.name }}
                                @if (!lastPrimerName) {
                                    ;
                                }
                            </p>
                        }
                    </div>
                </div>
            </div>
        }
    </div>

    <div id="order-samples-container">
        <p class="table-label">{{ 'order.orderDetailsSamples' | translate }}: {{ samples().length }}</p>
        <div class="table-header">
            <div>{{ 'sample' | translate }}</div>
            <div>{{ 'size' | translate }}</div>
            <div>{{ 'dnaType' | translate }}</div>
        </div>
        @for (sample of samples(); track sample; let index = $index) {
            <div class="table-row">
                <div>
                    <p [id]="'order-details-sample-name-' + index">
                        {{ sample.sampleName }}
                    </p>
                    <p [id]="'order-details-sample-barcode-' + index" class="tube-barcode">
                        <span class="tube-barcode-text">{{ sample.barcode ?? '-' }}</span>
                        <i class="fa-regular fa-barcode"></i>
                    </p>
                </div>
                <div>{{ sample.size }}bp</div>

                @switch (sample.dnaType) {
                    @case (dnaTypes.PCR) {
                        <div>
                            {{ 'order.reactionDetails.dnaType.PCR' | translate }}
                        </div>
                    }
                    @case (dnaTypes.PLASMID) {
                        <div>
                            {{ 'order.reactionDetails.dnaType.plasmid' | translate }}
                        </div>
                    }
                }
            </div>
        }
    </div>

    <div id="order-samples-container-mobile">
        <p class="table-label">{{ 'order.orderDetailsSamples' | translate }}: {{ samples().length }}</p>
        @for (sample of samples(); track sample; let index = $index) {
            <div class="table-row" [ngClass]="index % 2 === 0 ? 'even' : 'odd'">
                <div class="item">
                    <span class="label">{{ 'sample' | translate }}:</span>
                    <p [id]="'order-details-sample-name-' + index">
                        {{ sample.sampleName }}
                    </p>
                </div>
                <div class="item">
                    <span class="label">{{ 'size' | translate }}:</span>
                    <div>{{ sample.size }}bp</div>
                </div>
                <div class="item">
                    <span class="label">{{ 'dnaType' | translate }}:</span>

                    @switch (sample.dnaType) {
                        @case (dnaTypes.PCR) {
                            <div>
                                {{ 'order.reactionDetails.dnaType.PCR' | translate }}
                            </div>
                        }
                        @case (dnaTypes.PLASMID) {
                            <div>
                                {{ 'order.reactionDetails.dnaType.plasmid' | translate }}
                            </div>
                        }
                    }
                </div>
                <div class="item">
                    <span class="label">{{ 'barcode' | translate }}:</span>
                    <p id="'order-details-sample-barcode-' + index">
                        {{ sample.barcode ?? '-' }}
                    </p>
                </div>
            </div>
        }
    </div>

    @if (primers().length) {
        <div id="order-primers-container">
            <p class="table-label">{{ 'order.orderDetailsPrimers' | translate }}: {{ primers().length }}</p>
            <div class="table-header">
                <div>{{ 'primer' | translate }}</div>
                <div>{{ 'order.orderDetailsPrimersSource' | translate }}</div>
                <div>{{ 'sequence' | translate }}</div>
            </div>
            @for (primer of primers(); track primer; let index = $index) {
                <div class="table-row">
                    <div>
                        <p [id]="'order-details-primer-name-' + index">
                            {{ primer.name }}
                        </p>
                        @if (primer.barcode) {
                            <p [id]="'order-details-primer-barcode-' + index" class="tube-barcode">
                                <span class="tube-barcode-text">
                                    {{ primer.barcode }}
                                </span>
                                <i class="fa-regular fa-barcode"></i>
                            </p>
                        }
                    </div>

                    @switch (primer.primerSource) {
                        @case (primerTypes.STANDARD) {
                            <div>{{ 'standard' | translate }}</div>
                        }
                        @case (primerTypes.CUSTOM) {
                            <div>{{ 'custom' | translate }}</div>
                        }
                        @case (primerTypes.SHIPPED) {
                            <div>{{ 'shipped' | translate }}</div>
                        }
                    }

                    <p [id]="'order-details-primer-sequence-' + index">
                        {{ primer.sequence ?? '-' }}
                    </p>
                </div>
            }
        </div>

        <div id="order-primers-container-mobile">
            <p class="table-label">{{ 'order.orderDetailsPrimers' | translate }}: {{ primers().length }}</p>
            @for (primer of primers(); track primer; let index = $index) {
                <div class="table-row" [ngClass]="index % 2 === 0 ? 'even' : 'odd'">
                    <div class="item">
                        <span class="label">{{ 'primer' | translate }}:</span>
                        <p [id]="'order-details-primer-name-' + index">{{ primer.name }}</p>
                    </div>
                    <div class="item">
                        <span class="label">{{ 'order.orderDetailsPrimersSource' | translate }}:</span>

                        @switch (primer.primerSource) {
                            @case (primerTypes.STANDARD) {
                                <div>{{ 'standard' | translate }}</div>
                            }
                            @case (primerTypes.CUSTOM) {
                                <div>{{ 'custom' | translate }}</div>
                            }
                            @case (primerTypes.SHIPPED) {
                                <div>{{ 'shipped' | translate }}</div>
                            }
                        }
                    </div>
                    <div class="item">
                        <span class="label">{{ 'sequence' | translate }}:</span>
                        <p [id]="'order-details-primer-sequence-' + index">
                            {{ primer.sequence ?? '-' }}
                        </p>
                    </div>
                    <div class="item">
                        <span class="label">{{ 'barcode' | translate }}:</span>
                        <p [id]="'order-details-primer-barcode-' + index">
                            {{ primer.barcode ?? '-' }}
                        </p>
                    </div>
                </div>
            }
        </div>
    }
</div>
